import { render, staticRenderFns } from "./ApproverCstoPo.vue?vue&type=template&id=34699e60&scoped=true&"
import script from "./ApproverCstoPo.vue?vue&type=script&lang=js&"
export * from "./ApproverCstoPo.vue?vue&type=script&lang=js&"
import style0 from "./ApproverCstoPo.vue?vue&type=style&index=0&id=34699e60&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34699e60",
  null
  
)

export default component.exports